// btw-front/src/api/companySearch.js
import { api } from "./client";

// 고객사명 검색 — 백엔드 프록시(/api/company-search) 경유(공공데이터포털 국민연금 사업장).
// 2글자 미만은 호출하지 않음. 반환: [{ name, businessNumberPrefix, address, industry, isCorp }]
export async function search(q) {
  const keyword = (q || "").trim();
  if (keyword.length < 2) return [];
  const res = await api.get(`/company-search?q=${encodeURIComponent(keyword)}`);
  return (res && res.items) || [];
}

// 다른 파트너(관리자)가 이미 등록한 고객사인지 — 선택 즉시 중복 체크.
//   excludeDealId = 수정 중 자기 딜 제외용(선택), businessNumber = 고객사 사업자등록번호(선택).
//   반환 { taken, similar } — taken 은 차단, similar 는 차단하지 않는 유사 고객사 안내
//   ([{ customerCompany(마스킹), reason }]). 회사명은 서버가 첫 1자만 남겨 내려준다.
export async function customerTaken(company, excludeDealId, businessNumber) {
  const name = (company || "").trim();
  if (!name) return { taken: false, similar: [] };
  const params = new URLSearchParams({ company: name });
  if (excludeDealId) params.set("excludeDealId", String(excludeDealId));
  if (businessNumber) params.set("businessNumber", String(businessNumber));
  const res = await api.get(`/deals/customer-taken?${params.toString()}`);
  return { taken: !!(res && res.taken), similar: (res && res.similar) || [] };
}
